import { FC, useMemo } from 'react'
import { ButtonTransformer } from 'src/relay/Transformers/ButtonTransormer'
import { ImageTransformer } from 'src/relay/Transformers/ImageTransformer'
import ActionGrid, { ActionGridProps } from 'src/components/ActionGrid'
import Router from 'src/routes/Router'
import routes from 'src/routes/definitions'
import { getThemeColor } from 'src/relay/Transformers/ThemeTransformer'

import { BlockProps } from '../props'

import { ActionsEngageesBlockProps } from './props'

const ActionsEngageesBlock: FC<BlockProps<ActionsEngageesBlockProps>> = ({
  data,
  locale,
}) => {
  const props: ActionGridProps = useMemo(
    () => ({
      ...(data.title && {
        blockTitleProps: {
          title: data.title,
          ...(data.description && {
            richTextProps: { html: data.description || '' },
          }),
          actionButtonProps: ButtonTransformer({
            data: data.cta,
            theme: data.theme?.data,
          }),
          htmlTag: 'header',
          color: getThemeColor(data?.theme?.data),
        },
      }),
      // v4: `engagements.data[].attributes`; v5: flat array.
      actions: ((data.engagements as any)?.data ?? data.engagements ?? []).map(
        (itemRaw: any) => {
          const attrs: any = itemRaw?.attributes ?? itemRaw
          const desktopImage =
            attrs?.hero?.desktopImage?.data ?? attrs?.hero?.desktopImage
          const mobileImage =
            attrs?.hero?.mobileImage?.data ?? attrs?.hero?.mobileImage
          const imageProps = ImageTransformer(desktopImage, {
            desktop: '100vw',
            big: '50vw, 33vw',
          })
          const mobileImageProps = ImageTransformer(mobileImage, {
            desktop: '100vw',
            big: '50vw, 33vw',
          })
          return {
            linkProps: {
              text: attrs?.title,
              href: Router.getRouteUrl(routes.engagements, {
                slug: attrs?.slug,
                lang: locale,
              }),
              locale,
            },
            ...(imageProps && {
              pictureProps: {
                imageProps,
                ...(mobileImageProps && { mobileImageProps }),
              },
            }),
            color: getThemeColor(data?.theme?.data),
          }
        }
      ),
    }),
    [data, locale]
  )

  return <ActionGrid {...props} />
}

export default ActionsEngageesBlock
